<template>
  <v-layout
    row
    wrap
  >
    <span class="filter-field ma-2 body-2">{{ filter.label }}</span>
    <v-select
      v-model="filter.operator"
      :items="operators"
      class="ma-2"
      dense
      solo
    />
    <v-text-field
      :value="moneyValue"
      :prefix="currencySymbol"
      class="ma-2"
      dense
      solo
      @input="changeValue"
    />
    <v-icon
      @click="$emit('delete')"
    >
      cancel
    </v-icon>
  </v-layout>
</template>

<script>
import currencies from '@/../node_modules/js-money/lib/currency'
import Money from 'js-money'
import { mapGetters } from 'vuex'

export default {
  name: 'MoneyFilter',

  props: {
    filter: {
      type: Object,
      required: true,
      default: () => {}
    }
  },

  data () {
    return {
      operators: ['gt', 'gte', 'eq', 'lte', 'lt'],
      moneyValue: null
    }
  },

  computed: {
    ...mapGetters(['currency', 'currencySymbol'])
  },

  mounted () {
    if (this.filter.value) {
      this.moneyValue = Money.fromInteger({ amount: parseInt(this.filter.value), currency: this.currency })
    }
  },

  methods: {

    changeValue (value) {
      let currencyInfo = currencies[this.currency]
      this.filter.value = parseInt(parseFloat(value).toFixed(currencyInfo.decimal_digits).toString().replace(/[,.]/g, ''))
    }
  }
}
</script>

<style lang="stylus" scoped>
  .v-select {
    max-width: 100px
  }
  .v-icon {
    margin-top: -20px
  }
  .filter-field {
    margin-top: 20px !important
    min-width: 60px
  }
</style>
